import moment from "moment"
import styled from "styled-components"
import {ButtonPrimary} from "ui/base/Button/ButtonStyled"
import {Modal} from "ui/base/modal/Modal"
import {themeFontSize} from "ui/theme"

export const CancellationModal = ({
                                      show,
                                      handleClose,
                                      onCancel,
                                      onClose,
                                      cancellationData,
                                      isLoading
                                  }) => {
    return (
        <Modal show={show} handleClose={handleClose} minHeight={200} maxWidth={500}>
            <Container>
                <Title>Do you want to move forward with the class cancellation?</Title>
                {cancellationData?.booking_slots?.length > 1 ? (
                    <Description>
                        This class is part of a multi-class booking. Canceling this
                        class will automatically cancel the following classes:
                    </Description>
                ) : null}
                <ClassList>
                    <ClassTitle>Class: {cancellationData?.class_name}</ClassTitle>
                    <div>
                        {cancellationData?.booking_slots?.map((slot) => {
                            return (
                                <ClassItem key={slot.id}>
                                    {moment(
                                        `${slot?.class_date} ${slot?.class_time}`,
                                        "YYYY-MM-DD HH:mm:ss"
                                    ).format("MMM Do, YYYY - h:mm A")}
                                </ClassItem>
                            )
                        })}
                    </div>
                </ClassList>
                <RefundInfo>
                    Based on the cancellation policies, if you cancel the class at this
                    moment, your class refund would be:
                </RefundInfo>
                <strong>${cancellationData?.refund_amount}</strong>
                <ButtonContainer>
                    <ButtonPrimary onClick={onCancel} disabled={isLoading}>
                        Yes
                    </ButtonPrimary>
                    <ButtonPrimary
                        onClick={onClose}
                        disabled={isLoading}
                        variant='outline'>
                        No
                    </ButtonPrimary>
                </ButtonContainer>
            </Container>
        </Modal>
    )
}

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 1rem;
    gap: 1rem;
    width: 100%;
`

const Title = styled.h2`
    font-size: ${themeFontSize("medium")};
    text-align: center;
`

const Description = styled.p`
    font-size: ${themeFontSize("regular")};
    text-align: center;
`

const ClassList = styled.div`
    font-size: ${themeFontSize("small")};
    display: grid;
    gap: 0.5rem;
`

const ClassTitle = styled.h2`
    font-size: ${themeFontSize("medium")};
    text-align: center;
`

const ClassItem = styled.div`
    text-align: center;
`

const RefundInfo = styled.p`
    font-size: ${themeFontSize("regular")};
    text-align: center;
`

const ButtonContainer = styled.div`
    display: flex;
    width: 100%;
    gap: 1rem;

    & > * {
        width: 100%;
    }
`
